// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-code-form[data-v-4abbb234]{display:grid;grid-template-columns:1fr 56px 56px;column-gap:8px}.coupon-title[data-v-4abbb234]{display:flex;column-gap:4px;align-items:center;font-size:16px}.coupon-title .fa[data-v-4abbb234]{color:#59a153}.warning[data-v-4abbb234]{color:#ff7272}.code-button[data-v-4abbb234]{width:100%;height:100%}.button-label[data-v-4abbb234],.button-label .fa[data-v-4abbb234]{color:#fff;font-size:12px}", ""]);
// Exports
module.exports = exports;
